export default {"src":"/_next/static/media/propertyDamage_40.f7e0ed3c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};